export default function turnToPascalCase(value){
  let temp = value.split(" ");
  temp = temp.map((val) => val[0].toUpperCase() + val.slice(1).toLowerCase());
  return temp.join(" ");
}